
import FAQ4 from "../components/FAQ4";
import Footer from "../components/Footer";
import Header from "../components/Header";

function ConcertsEvents() {
  return (
    <>
    <section 
      className="relative w-full min-h-[40vh] sm:min-h-[50vh] lg:min-h-[60vh] bg-cover bg-center"
      style={{
        backgroundImage: "url('blog12.png')",
      }}
    >
      <Header/>

      {/* Hero Content */}
      <div className="relative z-20 flex items-center justify-center min-h-[40vh] sm:min-h-[50vh] lg:min-h-[60vh] px-4">
        <div className="max-w-5xl text-center text-white">
          <h1 className="font-bold leading-snug text-white">
            Concerts & Events
          </h1>
          <div className="mt-6 flex justify-center gap-2 text-sm font-medium">
            <a href="/" className="hover:text-logo-green">Home</a>
            <span>-</span>
            <span className="text-logo-green">Concerts & Events</span>
          </div>
        </div>
      </div>
    </section>

       <section className="bg-white py-10 sm:py-10 px-4 sm:px-6 lg:px-10">
  <div className="max-w-[1200px] mx-auto">
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 items-center">
      {/* Image Side - First on mobile, left on desktop */}
      <div className="order-1 lg:order-1">
        <img 
          src="fleet6.png" 
          alt="Luxury Concert Limo Service NYC" 
          className="w-full h-64 sm:h-80 lg:h-96 object-cover rounded-lg shadow-lg"
        />
      </div>

      {/* Text Side - Second on mobile, right on desktop */}
      <div className="order-2 lg:order-2">
        <h2 className="font-bold text-black mb-3 sm:mb-4 leading-tight">
          Luxury Concert Limo Service in New York City
        </h2>
        <p className="mb-3 sm:mb-4 leading-relaxed text-gray-900">
          Looking for a concert limo service in NYC that delivers luxury, reliability, and stress-free transportation? Our concert limousine service is designed for music lovers who want to arrive in style, avoid traffic headaches, and enjoy a premium experience from pickup to drop-off.
        </p>
        <p className="mb-4 sm:mb-6 leading-relaxed text-gray-900">
          Whether you're attending a concert at Madison Square Garden, Barclays Center, MetLife Stadium, Yankee Stadium, UBS Arena, Radio City Music Hall, or any venue in the New York metro area, our professional limo service ensures your night is unforgettable.
        </p>
        <div className="flex flex-col sm:flex-row gap-4">
          <a 
            href="/booknow" 
            className="bg-black border-2 border-white text-white px-6 sm:px-8 py-3 font-semibold hover:bg-gray-900 transition-colors text-center"
          >
            BOOK NOW
          </a>
          <a 
            href="tel:+17182004140" 
            className="bg-white text-black border-2 border-black px-6 sm:px-8 py-3 font-semibold hover:bg-gray-100 transition-colors text-center"
          >
            CALL NOW
          </a>
        </div>
      </div>
    </div>
  </div>
</section>

<section className="bg-white py-8 sm:py-8 px-4 sm:px-6 lg:px-10">
  <div className="max-w-[1200px] mx-auto">
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 items-center">
      {/* Text Side - First on mobile, left on desktop */}
      <div className="order-1 lg:order-1">
        <h2 className="font-bold text-black mb-3 sm:mb-4 leading-tight">
          Why Choose Our Concert Limo Service in NYC?
        </h2>
        <p className="mb-3 sm:mb-4 leading-relaxed text-gray-900">
          Attending a concert should be exciting—not stressful. When you rent a limo for a concert, you eliminate parking hassles, long walks, and ride-share delays.
        </p>
        <p className="mb-3 sm:mb-4 leading-relaxed text-gray-900">
          Attending a concert is about excitement, music, and unforgettable moments. Choosing a limousine service for concerts elevates the entire experience by offering comfort, convenience, and luxury. Whether you're heading to a stadium show or an intimate live performance, our concert limousine service provides the top benefits for an enhanced experience.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4">
          <a 
            href="/booknow" 
            className="bg-black border-2 border-white text-white px-6 sm:px-8 py-3 font-semibold hover:bg-gray-900 transition-colors text-center"
          >
            BOOK NOW
          </a>
          <a 
            href="tel:+17182004140" 
            className="bg-white text-black border-2 border-black px-6 sm:px-8 py-3 font-semibold hover:bg-gray-100 transition-colors text-center"
          >
            CALL NOW
          </a>
        </div>
      </div>

      {/* Image Side - Second on mobile, right on desktop */}
      <div className="order-2 lg:order-2">
        <img 
          src="blog12.png" 
          alt="Why Choose Our Concert Limo Service NYC" 
          className="w-full h-64 sm:h-80 lg:h-96 object-cover rounded-lg shadow-lg"
        />
      </div>
    </div>
  </div>
</section>

<section className="bg-white py-8 sm:py-8 px-4 sm:px-6 lg:px-10">
  <div className="max-w-[1200px] mx-auto">
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 items-center">
      {/* Image Side - First on mobile, left on desktop */}
      <div className="order-1 lg:order-1">
        <img 
          src="fleet6.png" 
          alt="Concert Limo Transportation for All Major NYC Venues" 
          className="w-full h-64 sm:h-80 lg:h-96 object-cover rounded-lg shadow-lg"
        />
      </div>

      {/* Text Side - Second on mobile, right on desktop */}
      <div className="order-2 lg:order-2">
        <h2 className="font-bold text-black mb-3 sm:mb-4 leading-tight">
          Concert Limo Transportation for All Major NYC Venues
        </h2>
        <p className="mb-3 sm:mb-4 leading-relaxed text-gray-900">
          We provide concert limousine service to and from all major venues, including:
        </p>
        
        <ul className="text-base sm:text-lg mb-4 sm:mb-6 leading-relaxed space-y-2">
          <li className="flex items-start">
            <span className="mr-2">●</span>
            <span><strong>Madison Square Garden (MSG)</strong></span>
          </li>
          <li className="flex items-start">
            <span className="mr-2">●</span>
            <span><strong>Barclays Center</strong> (Brooklyn)</span>
          </li>
          <li className="flex items-start">
            <span className="mr-2">●</span>
            <span><strong>MetLife Stadium</strong> (NJ)</span>
          </li>
          <li className="flex items-start">
            <span className="mr-2">●</span>
            <span><strong>Yankee Stadium</strong></span>
          </li>
          <li className="flex items-start">
            <span className="mr-2">●</span>
            <span><strong>Citi Field</strong></span>
          </li>
          <li className="flex items-start">
            <span className="mr-2">●</span>
            <span><strong>UBS Arena</strong></span>
          </li>
          <li className="flex items-start">
            <span className="mr-2">●</span>
            <span><strong>Radio City Music Hall</strong></span>
          </li>
          <li className="flex items-start">
            <span className="mr-2">●</span>
            <span><strong>Beacon Theatre</strong></span>
          </li>
          <li className="flex items-start">
            <span className="mr-2">●</span>
            <span><strong>Brooklyn Steel</strong></span>
          </li>
          <li className="flex items-start">
            <span className="mr-2">●</span>
            <span><strong>Terminal 5</strong></span>
          </li>
          <li className="flex items-start">
            <span className="mr-2">●</span>
            <span><strong>Forest Hills Stadium</strong></span>
          </li>
        </ul>
        
        <div className="flex flex-col sm:flex-row gap-4">
          <a 
            href="/booknow" 
            className="bg-black border-2 border-white text-white px-6 sm:px-8 py-3 font-semibold hover:bg-gray-900 transition-colors text-center"
          >
            BOOK NOW
          </a>
          <a 
            href="tel:+17182004140" 
            className="bg-white text-black border-2 border-black px-6 sm:px-8 py-3 font-semibold hover:bg-gray-100 transition-colors text-center"
          >
            CALL NOW
          </a>
        </div>
      </div>
    </div>
  </div>
</section>

<section className="bg-white py-8 sm:py-8 px-4 sm:px-6 lg:px-10">
  <div className="max-w-[1200px] mx-auto">
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 items-center">
      {/* Text Side - First on mobile, left on desktop */}
      <div className="order-1 lg:order-1">
        <h2 className="font-bold text-black mb-3 sm:mb-4 leading-tight">
          Our Concert Limo Fleet
        </h2>
        <p className="mb-3 sm:mb-4 leading-relaxed text-gray-900">
          Choose the perfect vehicle for your night out:
        </p>
        
        <ul className="text-base sm:text-lg mb-4 sm:mb-6 leading-relaxed space-y-2">
          <li className="flex items-start">
            <span className="mr-2">●</span>
            <span><strong>Stretch Limousines:</strong> Classic luxury for couples or small groups</span>
          </li>
          <li className="flex items-start">
            <span className="mr-2">●</span>
            <span><strong>Luxury SUVs:</strong> Discreet, stylish, and comfortable</span>
          </li>
          <li className="flex items-start">
            <span className="mr-2">●</span>
            <span><strong>Mercedes Sprinter Vans:</strong> Ideal for mid-size groups</span>
          </li>
          <li className="flex items-start">
            <span className="mr-2">●</span>
            <span><strong>Party Buses:</strong> LED lighting, sound systems, and room to celebrate</span>
          </li>
        </ul>
        
        <p className="mb-4 sm:mb-6 leading-relaxed text-gray-900">
          All vehicles are clean, modern, insured, and professionally maintained.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4">
          <a 
            href="/booknow" 
            className="bg-black border-2 border-white text-white px-6 sm:px-8 py-3 font-semibold hover:bg-gray-900 transition-colors text-center"
          >
            BOOK NOW
          </a>
          <a 
            href="tel:+17182004140" 
            className="bg-white text-black border-2 border-black px-6 sm:px-8 py-3 font-semibold hover:bg-gray-100 transition-colors text-center"
          >
            CALL NOW
          </a>
        </div>
      </div>

      {/* Image Side - Second on mobile, right on desktop */}
      <div className="order-2 lg:order-2">
        <img 
          src="blog12.png" 
          alt="Our Concert Limo Fleet" 
          className="w-full h-64 sm:h-80 lg:h-96 object-cover rounded-lg shadow-lg"
        />
      </div>
    </div>
  </div>
</section>

<section className="bg-white py-8 sm:py-8 px-4 sm:px-6 lg:px-10">
  <div className="max-w-[1200px] mx-auto">
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 items-center">
      {/* Image Side - First on mobile, left on desktop */}
      <div className="order-1 lg:order-1">
        <img 
          src="fleet6.png" 
          alt="How Our Concert Limousine Service Works" 
          className="w-full h-64 sm:h-80 lg:h-96 object-cover rounded-lg shadow-lg"
        />
      </div>

      {/* Text Side - Second on mobile, right on desktop */}
      <div className="order-2 lg:order-2">
        <h2 className="font-bold text-black mb-3 sm:mb-4 leading-tight">
          How Our Concert Limousine Service Works
        </h2>
        
        <ul className="text-base sm:text-lg mb-4 sm:mb-6 leading-relaxed space-y-2">
          <li className="flex items-start">
            <span className="mr-2">●</span>
            <span><strong>Book Your Limo:</strong> Choose your date, venue, and vehicle</span>
          </li>
          <li className="flex items-start">
            <span className="mr-2">●</span>
            <span><strong>Pickup at Your Location:</strong> Home, hotel, or restaurant</span>
          </li>
          <li className="flex items-start">
            <span className="mr-2">●</span>
            <span><strong>Enjoy the Ride:</strong> Relax while your chauffeur handles traffic</span>
          </li>
          <li className="flex items-start">
            <span className="mr-2">●</span>
            <span><strong>Concert Drop-Off:</strong> Right at the venue entrance</span>
          </li>
          <li className="flex items-start">
            <span className="mr-2">●</span>
            <span><strong>Post-Concert Pickup:</strong> No waiting, no surge pricing</span>
          </li>
        </ul>
        
        <p className="mb-4 sm:mb-6 leading-relaxed text-gray-900">
          Our chauffeurs coordinate timing to ensure a smooth exit after the show.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4">
          <a 
            href="/booknow" 
            className="bg-black border-2 border-white text-white px-6 sm:px-8 py-3 font-semibold hover:bg-gray-900 transition-colors text-center"
          >
            BOOK NOW
          </a>
          <a 
            href="tel:+17182004140" 
            className="bg-white text-black border-2 border-black px-6 sm:px-8 py-3 font-semibold hover:bg-gray-100 transition-colors text-center"
          >
            CALL NOW
          </a>
        </div>
      </div>
    </div>
  </div>
</section>

<section className="bg-white py-8 sm:py-8 px-4 sm:px-6 lg:px-10">
  <div className="max-w-[1200px] mx-auto">
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 items-center">
      {/* Text Side - First on mobile, left on desktop */}
      <div className="order-1 lg:order-1">
        <h2 className="font-bold text-black mb-3 sm:mb-4 leading-tight">
          Benefits of Using Limousine Services for Concerts
        </h2>
        <p className="mb-3 sm:mb-4 leading-relaxed text-gray-900">
          Attending a concert is about excitement, music, and unforgettable moments. Choosing a limousine service for concerts elevates the entire experience by offering comfort, convenience, and luxury. Whether you're heading to a stadium show or an intimate live performance, here are the top benefits of using a concert limousine service.
        </p>
        <p className="mb-3 sm:mb-4 leading-relaxed text-gray-900">
          When you rent a limo for a concert, you enjoy VIP treatment, travel together as a group, avoid parking fees, and enhance your overall concert experience. A concert limo service provides luxury transportation to and from concert venues, offering comfort, safety, and convenience without parking or traffic stress.
        </p>
        <p className="mb-4 sm:mb-6 leading-relaxed text-gray-900">
          Pricing depends on vehicle type, hours, distance, and group size. Contact us for a custom concert limo quote with no hidden fees. Is renting a limo for a concert worth it? Yes. We offer round-trip concert limousine service with post-event pickup coordination.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4">
          <a 
            href="/booknow" 
            className="bg-black border-2 border-white text-white px-6 sm:px-8 py-3 font-semibold hover:bg-gray-900 transition-colors text-center"
          >
            BOOK NOW
          </a>
          <a 
            href="tel:+17182004140" 
            className="bg-white text-black border-2 border-black px-6 sm:px-8 py-3 font-semibold hover:bg-gray-100 transition-colors text-center"
          >
            CALL NOW
          </a>
        </div>
      </div>

      {/* Image Side - Second on mobile, right on desktop */}
      <div className="order-2 lg:order-2">
        <img 
          src="blog12.png" 
          alt="Benefits of Using Limousine Services for Concerts" 
          className="w-full h-64 sm:h-80 lg:h-96 object-cover rounded-lg shadow-lg"
        />
      </div>
    </div>
  </div>
</section>
    
    <FAQ4/>

    <Footer/>
    </>
  );
}

export default ConcertsEvents;
